import React from 'react'
import { Header, Navbar } from '../components'
import { Link } from 'react-router-dom'
import { Images } from '../constants'
const Works = () => {
  return (
    <div className='flex flex-col'>
      <Header />
      <Navbar/>
      <div className='bg-gray-800 h-[40vh] flex justify-center items-center '>
        <h1 className='text-center text-white text-6xl poppins-bold'>Our Works</h1>
      </div>
      <div className='bg-gray-200 h-20 flex items-center flex-row px-28 justify-between' >
        <Link><div>
          <h1 className=' text-blue-950 poppins-bold'>All projects</h1>
        </div>
        </Link>
        <Link><div>
          <h1 className=' text-blue-950 poppins-bold'>Web Application</h1>
        </div>
        </Link>
        <Link><div>
          <h1 className=' text-blue-950 poppins-bold'>Android/IOS</h1>
        </div>
        </Link>
        <Link><div>
          <h1 className=' text-blue-950 poppins-bold'>UI/UX</h1>
        </div>
        </Link>
        <Link><div>
          <h1 className=' text-blue-950 poppins-bold'>SEO</h1>
        </div>
        </Link>
        <Link><div>
          <h1 className=' text-blue-950 poppins-bold'>Maintanance</h1>
        </div>
        </Link>

      </div>
      <div className='projects bg-gray-900 flex m-2 flex-row p-2 rounded-lg'>
        <div className='   w-2/4 p-2  flex items-center'  >
          <img src={Images.DEFAULT_WORKS_IMAGE} alt='project' className='rounded-lg' />

        </div>
        <div className=' flex flex-col w-3/5 py-5'>
          <h1 className='text-2xl poppins-bold text-white'>ChordBeat</h1>

</div>

      </div>
    </div>
  )
}

export default Works